import React from 'react';
import Container from 'react-bootstrap/Container';

interface ProductSectionProps {
    className?: string;
    domId: string;
    pageSectionRef?: React.RefObject<HTMLDivElement>;
    subTitle?: string;
    title: string;
}

const ProductSection: React.FC<ProductSectionProps> = ({
    children,
    className = '',
    domId,
    pageSectionRef,
    subTitle,
    title,
}) => {
    return (
        <div className={`${className} py-5`.trim()} data-dom-id={domId} ref={pageSectionRef}>
            <Container>
                <div className="border-bottom border-dark mb-4 pb-3">
                    <h2 className="font-weight-light sticky-nav-target" id={domId}>
                        {title}
                    </h2>
                    {!!subTitle && <h3 className="font-weight-light">{subTitle}</h3>}
                </div>
                {children}
            </Container>
        </div>
    );
};

export { ProductSection, ProductSectionProps };
